import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";
import { trackEvent } from "../analytics";

const FeedbackModal = ({ open, onClose }) => {
  const [feedback, setFeedback] = useState("");
  const supportEmail =
    process.env.REACT_APP_SUPPORT_EMAIL || "noreply.reeltale@gmail.com";

  const handleSend = () => {
    const subject = encodeURIComponent("Feedback for ReelTale");
    const body = encodeURIComponent(feedback);
    trackEvent("Send Feedback", { feedback });
    window.location.href = `mailto:${supportEmail}?subject=${subject}&body=${body}`;
    setFeedback("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Send Feedback</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Your Feedback"
          type="text"
          fullWidth
          multiline
          minRows={4}
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleSend}
          disabled={!feedback.trim()}
          variant="contained"
        >
          Send
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FeedbackModal;
